angular.module('angus.controllers').controller('arSummaryFuelPakCtrl', [
    '$scope', '$rootScope', '$http', '_', 'hierarchyService', 'moment',
    function($scope, $rootScope, $http, _, hierarchyService, moment) {
    	'use strict';
    	
		var divisionIds = hierarchyService.getLeafNodeEntityIds($rootScope.user.hierarchy.division.nodes, $scope.widget.instance.settings.hierarchyNodeId);

		function getArSummary() {
			return $http({
				url: ('api/subscribers/{0}/accountsReceivable/summary').format($rootScope.user.subscriberId),
				method: 'POST',
				data: {
					divisions: divisionIds,
					arDate: moment().format()
				}
			});
		}

		function init() {
			$scope.widget.noContentFlag = false;

			return $scope.widget.promises.monitor(
				getArSummary()
				.then(function(summary) {
					if (!summary) $scope.widget.noContentFlag = true;
					else $scope.summary = summary.data;
				}));
		}

        $scope.widget.setDefaultInitialization(init);		

		$scope.$on('widgetSettingsChanged', function() {
            divisionIds = hierarchyService.getLeafNodeEntityIds($rootScope.user.hierarchy.division.nodes, $scope.widget.instance.settings.hierarchyNodeId);
			init();
        });		
    }
]);